import React, { Fragment, useState } from "react";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from '../../components/Help-Desk-Components/Footer/Footer';
import "./steps.css";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import HeaderBuga from "../../components/header6/Header6";


const OnboardingFAQ = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [activeIndex, setActiveIndex] = useState(1); // Default FAQ 1 open

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
         <section
          className="page-title pt-100 md:pt-30 pos-rel bg_img breadcrums-bgr"
          // style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap ">
             <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding FAQ</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="section sofax-section-padding2  pt-65 pb-130"
          style={{ background: "#f3fff7" }}
        >
          <div className="container mt-5" bis_skin_checked={1}>
            <div
              className="row clearfix"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 1 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 1 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(1)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          1. I'm getting a black blank screen. What should I do?
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 1 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 1 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 1 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 1 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>Does your screen look something like this?</p>
                        <div className="row" bis_skin_checked={1}>
                          <div
                            className="col-6 col-md-5 col-lg-2"
                            bis_skin_checked={1}
                          >
                            <div className="cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/blankscreen1.png"
                                alt="I'm getting a black blank screen. What should I do?"
                              />
                            </div>
                          </div>
                          <div
                            className="col-6 col-md-5 col-lg-2"
                            bis_skin_checked={1}
                          >
                            <div className="cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/blankscreen2.png"
                                alt="I'm getting a black blank screen. What should I do?"
                              />
                            </div>
                          </div>
                        </div>
                        <p>
                          This means the CAMERA access to your default BROWSER
                          is denied. Please follow the steps below to Allow
                          camera access.
                        </p>
                        <ul
                          className="nav nav-pills nav-justified flex-column flex-sm-row style1"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li className="nav-item" role="presentation">
                            <a
                              className="nav-link rounded"
                              id="pills-cloud-tab"
                              data-bs-toggle="pill"
                              href="#iOS"
                              role="tab"
                              aria-controls="pills-cloud"
                              aria-selected="false"
                              bis_skin_checked={1}
                              tabIndex={-1}
                            >
                              <div
                                className="text-center py-2"
                                bis_skin_checked={1}
                              >
                                <h6 className="mb-0">iOS</h6>
                              </div>
                            </a>
                            {/*end nav link*/}
                          </li>
                          {/*end nav item*/}
                          <li className="nav-item" role="presentation">
                            <a
                              className="nav-link rounded active"
                              id="pills-smart-tab"
                              data-bs-toggle="pill"
                              href="#android"
                              role="tab"
                              aria-controls="pills-smart"
                              aria-selected="true"
                              bis_skin_checked={1}
                            >
                              <div
                                className="text-center py-2"
                                bis_skin_checked={1}
                              >
                                <h6 className="mb-0">Android</h6>
                              </div>
                            </a>
                            {/*end nav link*/}
                          </li>
                          {/*end nav item*/}
                        </ul>
                        {/*end nav pills*/}
                        <div className="row" bis_skin_checked={1}>
                          <div
                            className="col-12 mt-1 pt-1"
                            bis_skin_checked={1}
                          >
                            <div
                              className="tab-content"
                              id="pills-tabContent"
                              bis_skin_checked={1}
                            >
                              <div
                                className="tab-pane fade"
                                id="iOS"
                                role="tabpanel"
                                aria-labelledby="pills-cloud-tab"
                                bis_skin_checked={1}
                              >
                                <div
                                  className="row align-items-center"
                                  bis_skin_checked={1}
                                >
                                  <div
                                    className="col-md-12 mt-1 mt-sm-0 pt-0 pt-sm-0"
                                    bis_skin_checked={1}
                                  >
                                    <div
                                      className="full mb-1"
                                      bis_skin_checked={1}
                                    >
                                      <div
                                        className="row wow fadeInUp animated animated animated"
                                        data-wow-delay="0.4s"
                                        style={{
                                          visibility: "visible",
                                          animationDelay: "0.4s",
                                          animationName: "fadeInUp",
                                        }}
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="col-12 col-md-12 col-xs-12 offset-xs-1"
                                          bis_skin_checked={1}
                                        >
                                          <p>i. Go to Settings → Safari</p>
                                          <div
                                            className="row"
                                            bis_skin_checked={1}
                                          >
                                            <div
                                              className="col-12 col-md-5 col-lg-3"
                                              bis_skin_checked={1}
                                            >
                                              <div
                                                className="cardcss"
                                                bis_skin_checked={1}
                                              >
                                                <img
                                                  className="card-img-top"
                                                  src=" /photo/apple1.png"
                                                  alt="Step1"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <p>
                                            ii. Scroll to find "Camera" under
                                            SETTINGS FOR WEBSITES section
                                          </p>
                                          <div
                                            className="row"
                                            bis_skin_checked={1}
                                          >
                                            <div
                                              className="col-12 col-md-5 col-lg-3"
                                              bis_skin_checked={1}
                                            >
                                              <div
                                                className="cardcss"
                                                bis_skin_checked={1}
                                              >
                                                <img
                                                  className="card-img-top"
                                                  src=" /photo/apple2.png"
                                                  alt="Step2"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <p>
                                            iii. Tap on Camera option and you
                                            will be navigated to CAMERA ACCESS
                                            ON ALL WEBSITES. Tap on "Allow"
                                            option.
                                          </p>
                                          <div
                                            className="row"
                                            bis_skin_checked={1}
                                          >
                                            <div
                                              className="col-12 col-md-5 col-lg-3"
                                              bis_skin_checked={1}
                                            >
                                              <div
                                                className="cardcss"
                                                bis_skin_checked={1}
                                              >
                                                <img
                                                  className="card-img-top"
                                                  src=" /photo/apple3.png"
                                                  alt="Step1"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/*end col*/}
                                </div>
                                {/*end row*/}
                              </div>
                              {/*end teb pane*/}
                              <div
                                className="tab-pane fade active show"
                                id="android"
                                role="tabpanel"
                                aria-labelledby="pills-smart-tab"
                                bis_skin_checked={1}
                              >
                                <div
                                  className="row align-items-center"
                                  bis_skin_checked={1}
                                >
                                  <div
                                    className="col-md-12 mt-1 mt-sm-0 pt-0 pt-sm-0"
                                    bis_skin_checked={1}
                                  >
                                    <p>i. Go to Settings and tap on Apps</p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src=" /photo/ad1.png"
                                            alt="Step1"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      ii. Scroll to find your default browser
                                      app. Mostly it is Google Chrome for
                                      Android device, unless explicitly changed.
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src=" /photo/ad2.png"
                                            alt="Step2"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      iii. Chrome → Permissions will show you
                                      what is enabled. Camera permission need to
                                      be enabled here.{" "}
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src=" /photo/ad3.png"
                                            alt="Step3"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      iv. App permissions will show what is
                                      allowed and what's denied.
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src=" /photo/ad4.png"
                                            alt="Step4"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <p>
                                      v. Tap on Camera to Allow camera
                                      permission to Chrome.
                                    </p>
                                    <div className="row" bis_skin_checked={1}>
                                      <div
                                        className="col-12 col-md-5 col-lg-3"
                                        bis_skin_checked={1}
                                      >
                                        <div
                                          className="cardcss"
                                          bis_skin_checked={1}
                                        >
                                          <img
                                            className="card-img-top"
                                            src=" /photo/ad5.png"
                                            alt="Step5"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/*end col*/}
                                </div>
                                {/*end row*/}
                              </div>
                              {/*end teb pane*/}
                            </div>
                            {/*end tab content*/}
                          </div>
                          {/*end col*/}
                        </div>
                        {/*end row*/}
                      </div>
                    </div>
                  </li>
                  
                </ul>
              </div>    
            </div>



             <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  
                  <li className={`accordion block ${activeIndex === 2 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 2 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(2)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          2. I'm getting error message saying, "Wrong ID document or something went wrong..."{" "}
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 2 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 2 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 2 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 2 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>Does your screen look something like this?</p>
                        <div className="row" bis_skin_checked={1}>
                          <div
                            className="col-6 col-md-5 col-lg-3"
                            bis_skin_checked={1}
                          >
                            <div className="cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/ID Upload failure.png"
                                alt="Wrong ID document or something went wrong."
                              />
                            </div>
                          </div>
                        </div>
                        <p className="mt-2">
                          This means the ID you uploaded is not supported or was
                          having glare or blur while uploading. This may have
                          resulted us in not been able to capture ID details.
                          Please give it another try or contact our support
                          team.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>    
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 3 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 3 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(3)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          3. What face data does the app collect?
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 3 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 3 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 3 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 3 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          The application collects facial images (selfies) and facial biometric information derived from those images solely for identity verification and fraud prevention purposes. The facial image may be compared against the user's government-issued identity document to confirm that the user is the legitimate owner of the submitted identity document.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 4 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 4 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(4)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          4. Provide a complete and clear explanation of all planned uses of the collected face data.
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 4 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 4 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 4 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 4 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>The collected face data is used exclusively for:</p>
                        <ul className="ps-3" style={{ listStyleType: "disc" }}>
                          <li>Identity verification during customer onboarding (Know Your Customer / KYC).</li>
                          <li>Comparing a user's selfie against the photograph on a government-issued identity document.</li>
                          <li>Liveness detection to confirm that a real person is present and prevent spoofing or fraudulent account creation.</li>
                          <li>Fraud prevention, security monitoring, and compliance with anti-money laundering (AML) and counter-terrorist financing regulations.</li>
                          <li>Meeting regulatory obligations applicable to money transfer and financial services providers.</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 5 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 5 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(5)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          5. Will the face data be shared with any third parties? Where will this information be stored?
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 5 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 5 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 5 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 5 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          Face data may be shared only with Sumsub/GBG, that process the information on behalf of the company to perform identity verification and fraud prevention services.
                        </p>
                        <p>
                          Face data is not sold, rented, or shared for advertising purposes.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 6 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 6 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(6)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          6. How long will face data be retained?
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 6 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 6 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 6 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 6 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>Face data is retained only for as long as necessary to:</p>
                        <ul className="ps-3" style={{ listStyleType: "disc" }}>
                          <li>Complete identity verification.</li>
                          <li>Meet legal and regulatory requirements applicable to financial institutions and money service businesses.</li>
                          <li>Resolve disputes, enforce agreements, and prevent fraud.</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 7 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 7 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(7)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          7. Where in the privacy policy is the app's collection, use, disclosure, sharing, and retention of face data explained? Identify the specific sections in the privacy policy where this information is located.
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 7 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 7 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 7 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 7 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          The handling of face data is covered under the broader provisions for personal data in the following sections of the Privacy Policy:
                        </p>
                        <ul className="ps-3" style={{ listStyleType: "disc" }}>
                          <li><strong>Definitions:</strong> explains what qualifies as personal and sensitive data.</li>
                          <li><strong>Processing Personal Data:</strong> outlines how data is collected, stored, used, disclosed, and erased.</li>
                          <li><strong>Data Protection and Privacy Principles:</strong> sets rules for notice, choice, onward transfer, security, and integrity of data.</li>
                          <li><strong>Data Retention:</strong> describes how long personal data is kept and the conditions for its retention.</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 8 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 8 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(8)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          8. Quote the specific text from the privacy policy concerning face data.
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 8 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 8 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 8 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 8 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          "Personal Data means any information relating to a natural person who is identified or is identifiable by some number or characteristic...", 
                        </p>
                        <p>
                          "Sensitive Data is a subset of Personal Data and (subject to local requirements) may include but are not limited to race or ethnic origin, religious or philosophical beliefs, political affiliations/opinions, trade union membership, health information, sexual orientation, disabilities, certain types of personal financial data, etc.".
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 9 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 9 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(9)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          9. An explicit statement that face data is not retained:
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 9 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 9 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 9 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 9 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          Face data is retained solely for compliance with applicable legal, regulatory, and record-keeping obligations. It is not stored indefinitely and will be securely deleted once the retention period required under applicable law has expired.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 10 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 10 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(10)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          10. Your reasons for storing face data:
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 10 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 10 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 10 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 10 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          Face data is stored only where necessary to support identity verification processes, investigate suspected fraud, comply with applicable legal and regulatory obligations, and maintain records required for KYC verification.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 11 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 11 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(11)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          11. The length of time face data is stored and why you store it this specific length of time:
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 11 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 11 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 11 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 11 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          The data is stored for the time period necessary to fulfill business purposes or as required under applicable laws and regulations. Information is securely destroyed once it is no longer needed for these purposes, and retention practices are aligned with legal, regulatory, and compliance obligations.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 12 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 12 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(12)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          12. Which third parties you share face data with:
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 12 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 12 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 12 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 12 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          Face data may be shared with third-party identity verification and fraud prevention service providers engaged by Buga Money solely for the purpose of conducting liveness checks and verifying customer identity.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 13 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 13 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(13)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          13. Your reasons for sharing face data with third parties:
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 13 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 13 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 13 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 13 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          Buga Money shares face data with third-party identity verification providers exclusively to facilitate identity verification, conduct liveness detection, prevent fraud, comply with legal and regulatory obligations, and maintain the security and integrity of our services.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row clearfix mt-3"
              bis_skin_checked={1}
              style={{
                background: "#fff",
                borderRadius: "30px",
                boxShadow: "0 0 16px #e0e0e0",
                padding: "40px",
              }}
            >
              <div
                className="col-lg-12 col-md-12 col-sm-12 accordion-column"
                bis_skin_checked={1}
              >
                <ul className="accordion-box" style={{ listStyle: "none" }}>
                  <li className={`accordion block ${activeIndex === 14 ? 'active-block' : ''}`}>
                    <div 
                      className={`acc-btn ${activeIndex === 14 ? 'active' : ''}`} 
                      bis_skin_checked={1}
                      onClick={() => toggleAccordion(14)}
                      style={{ 
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon-box" bis_skin_checked={1} />
                        <h4 style={{ margin: 0, paddingRight: '15px' }}>
                          14. Do third-party providers store face data, and what are their retention practices?
                        </h4>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          background: activeIndex === 14 ? "#ffc107" : "#041b5f",
                          color: activeIndex === 14 ? "#000" : "#fff",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease, color 0.3s ease",
                          transform: activeIndex === 14 ? "rotate(180deg)" : "rotate(0deg)",
                          flexShrink: 0
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="acc-content"
                      bis_skin_checked={1}
                      style={{ display: activeIndex === 14 ? "block" : "none" }}
                    >
                      <div className="text" bis_skin_checked={1}>
                        <p>
                          Buga Money requires its third-party identity verification providers not to retain face data after completion of the verification process, except where retention is required by applicable law.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default OnboardingFAQ;
